import React from 'react';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import TextField from '@material-ui/core/TextField';
import Lightbox from 'lightbox-react';

import CircularProgress from '@material-ui/core/CircularProgress';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.form.actions';

import { TypeCameraIcon, TrashIcon } from '../../../../images/icons/WrapSvg';
import Task from './Task';
import Snackbar from '../../../labels/Snackbar';
import FileBase64 from '../../../inputs/Paint';

// eslint-disable-next-line
import style from './_styles.css';

function parse(json) {
    let result = [];
    if (json) {
        try {
            result = JSON.parse(json);
        } catch (e) {
            console.error(e);
            result = [];
        }
    }
    return result;
}

class Photo extends React.Component {
    state = {
        files: [],
        open: false,
        isLoading: false,
        autofocus: undefined,
        data: undefined,
        error: undefined,
        comment: '',
        point: 0,
        correction: 0,
        message: undefined,
        intervalId: undefined,
        desactivado: false,
    };

    static getDerivedStateFromProps(props, state) {
        const { data, parentDeactivated } = props;
        if (data !== state.data || parentDeactivated !== state.parentDeactivated) {
            state.files = data.valor ? parse(data.valor.replace("'", '"')) : [];
            state.desactivado = data.desactivado;
            state.parentDeactivated = parentDeactivated;
            state.data = data;
            return state;
        }
        return null;
    }

    async getFiles(arr) {
        const { files, data } = this.state;
        const valor = files.concat(arr);
        this.props.setValue(data.codigo, JSON.stringify(valor), '', false, {});
        this.setState({ isLoading: false, files: valor });
    }

    handleChangeComment = (comment, index) => {
        const { files, data } = this.state;
        const valor = [...files];
        valor[index].comentario = comment;
        this.props.setValue(data.codigo, JSON.stringify(valor), '', false, {});
        this.setState({ files: valor, autofocus: index });
    };

    handleDelete = (file) => {
        const { files, data } = this.state;
        const valor = [...files];
        const index = valor.indexOf(file);
        valor.splice(index, 1);
        this.props.setValue(data.codigo, JSON.stringify(valor), '', false, {});
        this.setState({ open: false, selected: undefined, files: valor });
    };

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked, files: [] });
    };

    handleChange = (valor) => {
        const file = this.state.selected;
        file.comentario = valor;
        this.setState({ selected: file });
    };

    handleClickOpen = (file) => {
        this.setState({ open: true, selected: file });
    };

    handleClose = (action) => {
        this.setState({ open: false, selected: undefined });
    };

    handleErrorUpload = (error) => {
        this.setState({ isLoading: false, error: error });
    };

    handleCloseError = () => {
        this.setState({ error: '' });
    };

    isLoading() {
        this.setState({ isLoading: true });
    }

    component = (data, name, intl, editable, desactivado, parentDeactivated) => {
        const { files, open, selected, isLoading, autofocus, error } = this.state;
        return (
            <div className="flex_full_row wrap margin_right__24">
                {!(!editable || data.disabled || desactivado || parentDeactivated) && (
                    <div className="upload-btn-wrapper margin_top_9">
                        {isLoading && (
                            <CircularProgress size={64} className={'fabProgress64 c_bluish'} />
                        )}
                        <button className="btn bg_ice_blue">
                            <TypeCameraIcon width={16} heigth={16} color={'primary'} />
                        </button>
                        <FileBase64
                            multiple={true}
                            onStart={this.isLoading.bind(this)}
                            onDone={this.getFiles.bind(this)}
                            onError={this.handleErrorUpload.bind(this)}
                            instance={this.props.instance}
                            field={data.codigo}
                        />
                    </div>
                )}
                {files.map((f, index) => {
                    if (f.thumbnail) {
                        const key = name.concat(index);
                        return (
                            <div className="flex_full_row margin_top_9" key={key}>
                                <img
                                    className="preview hand"
                                    src={`${process.env.REACT_APP_API_FILE}/${f.thumbnail}`}
                                    alt={f.name}
                                    height="64"
                                    width="64"
                                    id={`thumbnail-${index}`}
                                    onClick={() => this.handleClickOpen(f)}
                                />
                                {(!editable || data.disabled) && (
                                    <span className="barlow_regular_textwrap c_slate text_align_left">
                                        {f.comentario}
                                    </span>
                                )}
                                {!(!editable || data.disabled) && (
                                    <div className="flex_full_row elements_from_right">
                                        <TextField
                                            fullWidth
                                            multiline
                                            className="flex_auto_row"
                                            name={'txt-' + key}
                                            id={'txt-' + key}
                                            key={'txt-' + key}
                                            autoFocus={autofocus === index}
                                            label={intl.formatMessage({ id: 'form_field_comment' })}
                                            defaultValue={f.comentario}
                                            onChange={(event) =>
                                                this.handleChangeComment(event.target.value, index)
                                            }
                                        />
                                        {!data.modoTest &&
                                            <TrashIcon
                                                className={
                                                    'c_bluish margin_top_18 margin_right_18 hand'
                                                }
                                                onClick={() => this.handleDelete(f)}
                                            />
                                        }
                                    </div>
                                )}
                                {error && (
                                    <Snackbar
                                        open={true}
                                        variant="error"
                                        text={error}
                                        nonavbar={true}
                                        onClose={this.handleCloseError}
                                    />
                                )}
                            </div>
                        );
                    } else {
                        return <div />;
                    }
                })}

                {open && (
                    <Lightbox
                        mainSrc={`${process.env.REACT_APP_API_FILE}/${selected.link}`}
                        onCloseRequest={this.handleClose}
                    />
                )}
            </div>
        );
    };

    render() {
        const { files, desactivado, parentDeactivated } = this.state;
        const { data, last, intl, editable } = this.props;
        return (
            <Task
                key={data.codigo}
                data={data}
                desactivado={desactivado}
                value={files.length > 0 ? files : undefined}
                icon={<TypeCameraIcon color="primary" />}
                text="type_label_photo"
                last={last}
                parentDeactivated={parentDeactivated}
                editable={editable}
                allowed
                component={this.component(
                    data,
                    data.codigo,
                    intl,
                    editable,
                    desactivado,
                    parentDeactivated,
                )}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

Photo.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance: state.instance.id,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(Photo));



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/Photo.js